import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { SettingsIcon } from 'lucide-react';
import { EncabezadoPagina } from '../components/layout/AppLayout';
import { MapaAlmacen } from '../components/almacenes/MapaAlmacen';
import { useDatos } from '../contexts/DatosContext';
import { mapaDeAlmacenes } from '../utils/almacen';
export function Almacenes() {
  const {
    sucursales,
    almacenes,
    expedientes,
    sucursalActiva,
    setSucursalActiva,
    rol
  } = useDatos();
  const activas = sucursales.filter(s => s.activa);
  const sucursalId = sucursalActiva === 'todas' || !activas.some(s => s.id === sucursalActiva) ? activas[0]?.id ?? '' : sucursalActiva;
  const mapa = useMemo(() => mapaDeAlmacenes(almacenes, expedientes, sucursalId), [almacenes, expedientes, sucursalId]);
  const sucursal = sucursales.find(s => s.id === sucursalId);
  return <>
      <EncabezadoPagina titulo="Mapa de almacenes" descripcion="Navega Sucursal → Almacén → Pasillo → Estante → Caja para saber exactamente dónde está cada expediente." acciones={rol === 'Administrador' ? <Link to="/configuracion/sucursales" className="inline-flex h-9 items-center gap-2 rounded border border-gris-200 bg-white px-3 text-sm font-medium text-marino-700 transition-colors duration-150 hover:border-marino-300 hover:bg-marino-50" data-id="element-1080" data-mp="rav5pod75km5">
              <SettingsIcon className="h-4 w-4" aria-hidden="true" data-id="element-1081" data-mp="1f1gzqbqd94d5" />
              Configurar estructura
            </Link> : undefined} data-id="element-1079" data-mp="3n8xnsrazkgt" />

      <div className="mb-4 flex flex-wrap gap-2" data-id="element-1082" data-mp="160sv27mv4gcx">
        {activas.map(s => <button key={s.id} type="button" onClick={() => setSucursalActiva(s.id)} className={`h-9 rounded border px-3.5 text-sm font-medium transition-colors duration-150 ${s.id === sucursalId ? 'border-marino-800 bg-marino-800 text-white' : 'border-gris-200 bg-white text-gris-600 hover:border-gris-300'}`} data-id="element-1083" data-mp="1127s40g87iks">
            {s.nombre}
          </button>)}
      </div>

      {sucursal && <p className="mb-4 text-xs text-gris-500" data-id="element-1084" data-mp="3e9gz96siz4zp">
          {sucursal.direccion} · {sucursal.ciudad}, {sucursal.estado} · Tel. {sucursal.telefono}
        </p>}

      <MapaAlmacen almacenes={mapa} data-id="element-1085" data-mp="3j9v8ut9rymzu" />
    </>;
}